;(function () {
  'use strict';

  let angular = window.angular;
  let $ = window.$;

  ApiKeyFormController.$inject = [
    '$scope',
    '$timeout',
    'Customer',
    'AppUtils',
    '$filter'
  ];

  angular
    .module('app')
    .component('connectionApiKeyForm', {
      template:'<form class="validate" name="ctrl.apiForm" ng-class="{transparent: ctrl.saving}"><div class="modal-header"><span>{{:: ctrl.apiKey.id? \'form.actions.update\': \'form.actions.create\' | translate}}</span> <span translate>entities.apikey.modelName</span></div><div class="modal-body"><div><div class="form-group" show-errors><label for="createApiKeyName"><span translate>entities._all.name</span> <span class="text-danger">*</span></label> <input id="createApiKeyName" ng-model="ctrl.apiKey.name" class="form-control" translate-attr="{placeholder: \'entities._all.name\'}" name="apiKeyName" required><div class="help-block" ng-messages="ctrl.apiForm.apiKeyName.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group" show-errors><label for="createApiKeyTTL"><span translate>entities.apikey.ttl</span> <span class="text-danger">*</span></label> <input id="createApiKeyTTL" ng-focus="ctrl.date.open = !ctrl.date.open" ng-model="ctrl.apiKey.expiresAt" min="{{ctrl.date.min}}" type="datetime" class="form-control" datetime-picker="yyyy-MM-dd HH:mm" name="apiKeyTTL" is-open="ctrl.date.open" datepicker-options="ctrl.date.options" timepicker-options="ctrl.date.options" when-closed="ctrl.date.onClose(args)"><div class="help-block" ng-messages="ctrl.apiForm.apiKeyTTL.$error"><span ng-message="datetime" translate>form.errors.datetimeMinNow</span></div></div><div class="form-group marginT10"><div class="pull-left" style="position: relative; top: -4px"><div class="smart-form"><label class="toggle testmode"><input type="checkbox" ng-model="ctrl.apiKey.enabled" name="enabled"> <i data-swchon-text="True" data-swchoff-text="False"></i></label></div></div><label class="pull-left marginL10" style="line-height: 19px"><span translate>entities._all.enabled</span></label><div class="clearfix"></div></div><div class="form-group marginT10"><div class="pull-left" style="position: relative; top: -4px"><div class="smart-form"><label class="toggle testmode"><input type="checkbox" ng-model="ctrl.apiKey.testMode" name="testMode"> <i data-swchon-text="ON" data-swchoff-text="OFF"></i></label></div></div><label class="pull-left marginL10" style="line-height: 19px"><span translate>entities.apikey.testMode</span></label><div class="clearfix"></div></div></div></div><div ng-if="ctrl.createApiKeyError" class="alert alert-warning text-center marginB0">{{ctrl.createApiKeyError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" ng-show="!ctrl.saving" translate>buttons.cancel</button> <button ng-disabled="ctrl.saving" class="btn btn-primary" ng-click="ctrl.save()" translate>buttons.save</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner>',
      controller: ApiKeyFormController,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function ApiKeyFormController ($scope, $timeout, Customer, utils, $filter) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.apiKey = vm.resolve.apiKey ? angular.copy(vm.resolve.apiKey) : { enabled: true, testMode: false };
      vm.operation = vm.apiKey.id ? 'Update' : 'Create';
      vm.customer = vm.resolve.customer;
      vm.save = createApiKey;

      const since = new Date();
      since.setMinutes(5);
      vm.date = {
        open: false,
        min: $filter('date')(since, 'yyyy-MM-dd HH:mm'),
        options: {
          minDate: since,
          showMeridian: false,
          showWeeks: false
        }
      };
    };

    function createApiKey () {
      $scope.$broadcast('show-errors-check-validity');

      if (!vm.apiForm.$valid) {
        const errors = vm.apiForm.$error;
        if (Object.keys(errors).length !== 1 || !errors.time) {
          return;
        }
      }

      let created;
      if (vm.apiKey.created) {
        created = vm.apiKey.created.getTime ? vm.apiKey.created : new Date(vm.apiKey.created);
      } else {
        created = new Date();
      }
      created.setMilliseconds(0);

      if (vm.apiKey.expiresAt) {
        vm.apiKey.expiresAt.setMilliseconds(0);
      }

      const ttl = vm.apiKey.expiresAt ? Math.floor((vm.apiKey.expiresAt - created) / 1000) : -1;

      let apiKey = {
        name: vm.apiKey.name,
        testMode: vm.apiKey.testMode || false,
        enabled: vm.apiKey.enabled,
        ttl: ttl
      };

      let promise;
      if (vm.apiKey.id) {
        promise = Customer.apiKeys
          .updateById({
            id: vm.customer.id,
            fk: vm.apiKey.id
          }, apiKey)
          .$promise;
      } else {
        promise = Customer.apiKeys
          .create({
            id: vm.customer.id
          }, apiKey)
          .$promise;
      }

      vm.saving = true;
      promise
        .then(function (result) {
          vm.modalInstance.close({
            operation: vm.apiKey.id ? 'update' : 'create',
            apiKey: result,
            node: {
              id: result.id,
              text: result.name,
              parent: '#'
            }
          });
        })
        .catch(function (err) {
          vm.saving = false;
          vm.createApiKeyError = err.data;
        });
    }
  }
})();
